import { HeaderTestIds } from '@trello/webdriverio-tests';
import { forTemplate } from 'app/common/lib/util/i18n';
import { Button } from '@trello/nachos';
import {
  PopoverMenu,
  PopoverMenuButton,
} from 'app/gamma/src/components/popover/popover-menu';
import React from 'react';
import preventDefault from 'app/gamma/src/util/prevent-default';

import styles from './channel-switcher.less';
import { getTests } from 'app/gamma/src/selectors/channels';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';

const format = forTemplate('header_channel_picker');

interface ExperimentListProps {
  onSelectExperiment: (experimentName: string) => void;
}

const removeAllExperiments = () => {
  for (const experimentName of Object.keys(window.abTests)) {
    Cookies.set(`force_${experimentName}`, '', { path: '/', expires: -1 });
  }

  document.location.reload();
};

export const ExperimentList = ({ onSelectExperiment }: ExperimentListProps) => {
  const tests = useSelector(getTests);

  return (
    <div>
      <p>{format('listed-below-are-experiments')}</p>
      <p>{format('below-the-experiment')}</p>
      <Button
        appearance="danger"
        onClick={removeAllExperiments}
        data-test-id={HeaderTestIds.ChannelPickerRemoveAll}
        shouldFitContainer
      >
        {format('remove-all-experiments')}
      </Button>
      <PopoverMenu
        className={styles.popoverMenu}
        testId={HeaderTestIds.ChannelPickerExperimentList}
      >
        {tests.map((test) => {
          return (
            <PopoverMenuButton
              key={test.name}
              onClick={preventDefault(() => onSelectExperiment(test.name))}
              rawDescription={
                test.inExperiment ? `:: ${test.selectedVariation}` : undefined
              }
              description={
                !test.inExperiment ? format('not-in-experiment') : undefined
              }
            >
              {test.name}
            </PopoverMenuButton>
          );
        })}
      </PopoverMenu>
    </div>
  );
};
